export enum SearchType {
  Product = 'aanbod',
  Shop = 'bedrijf'
}
